import request from '@/libs/request'

// 订单列表
export function orderList (data) {
  return request({
    url: `pointorder/list`,
    method: 'get',
    params: data
  })
}

// 订单详情
export function orderInfo (data) {
  return request({
    url: `pointorder/info`,
    method: 'get',
    params: data
  })
}

// 订单发货信息
export function deliveryInfo (data) {
  return request({
    url: `pointorder/getDelivery`,
    method: 'get',
    params: data
  })
}

// 更改订单发货状态
export function changeFh (data) {
  return request({
    url: `pointorder/changeStatus`,
    method: 'post',
    data: data
  })
}
